/** Phase 2C — collaboration UX feature flags */

export function isCollabRealtimeEnabled(): boolean {
  return (
    isRealtimeEffective() && String(process.env.REACT_APP_COLLAB_REALTIME_ENABLED || '').toLowerCase() === 'true'
  );
}

export function isCollabPresenceEnabled(): boolean {
  return isCollabRealtimeEnabled() && String(process.env.REACT_APP_COLLAB_PRESENCE_ENABLED || '').toLowerCase() !== 'false';
}

export function isCollabConflictUxEnabled(): boolean {
  return isCollabRealtimeEnabled() && String(process.env.REACT_APP_COLLAB_CONFLICT_UX_ENABLED || '').toLowerCase() !== 'false';
}

export function isCollabTimelineEnabled(): boolean {
  return isCollabRealtimeEnabled() && String(process.env.REACT_APP_COLLAB_TIMELINE_ENABLED || '').toLowerCase() !== 'false';
}

function isRealtimeEffective(): boolean {
  return String(process.env.REACT_APP_REALTIME_ENABLED || '').toLowerCase() === 'true';
}
